import { useCallback, useEffect, useState, memo } from 'react';
import { I18n } from 'aws-amplify';
import { Box, MenuItem, TextField } from '@material-ui/core';
import { dropdownStyle } from '../common/ContractTableHandlerCss';
import '../NormalViewContractDetail.css';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import Utils from '@/common/utils/utils';
import { handleChangeSelect } from '../NormalViewContractDetailHanlder';

function DropdownSelect({
    isProduct,
    isEdition,
    isPaymentCycle,
    selectedItem,
    setSelectedItem,
    selectList,
    setSelectList,
    API,
    setIsLoading,

    product,
    setProduct,
    setProductList,
    setEditionList,
    setSelectedEdition,
    setSelectedVersion,
    setBasicSetting,
    setAdvanceSetting,
    setIsUpdateConfirm,
    contractDetail
}) {
    const [itemName, setItemName] = useState('');

    useEffect(() => {
        if(!Utils.isEmptyObject(selectedItem)) {
            setItemName(selectedItem.name)
        }
    }, [selectedItem])

    const handleChange = async item => {
        setIsUpdateConfirm(true);
        if(isProduct) {
            setIsLoading(true);
            
            await handleChangeSelect(
                API,
                item,
                setSelectedItem,
                setItemName,
                setSelectList,
                null,
                null,
                null,
                setEditionList,
                setSelectedEdition,
                setSelectedVersion,
                setBasicSetting,
                setAdvanceSetting,
                contractDetail
            );

            setIsLoading(false);
            return;
        }
        if(isEdition) {
            setIsLoading(true);

            await handleChangeSelect(
                API,
                item,
                setSelectedItem, 
                setItemName,
                setSelectList,
                product,
                setProduct,
                setProductList,
                setEditionList,
                setSelectedEdition,
                setSelectedVersion,
                setBasicSetting,
                setAdvanceSetting,
                contractDetail
            );

            setIsLoading(false);
            return;
        }

        // isPaymentCycle
        setSelectedItem(item);
        setItemName(item.name);
    };

    const handlerRenderLabel = useCallback(() => {
        if (isProduct) return I18n.get('DROPDOWN-SELECT-PRODUCT');
        if (isEdition) return I18n.get('DROPDOWN-SELECT-EDITION');
        if (isPaymentCycle) return I18n.get('DROPDOWN-PAYMENT-CYCLE');
        return '';
    }, [isProduct, isEdition, isPaymentCycle]);

    return (
        <Box className="dropdown-select-container" {...dropdownStyle.dropdown_select_container}>
            <Box component="span" {...dropdownStyle.dropdown_select_label}>
                {handlerRenderLabel()}
            </Box>
            <TextField
                    className="dropdown-select-input"
                    select
                    size="small"
                    value={itemName}
                    variant="outlined"
                    data-cy="header-top-select-project"
                    SelectProps={{
                        MenuProps: {
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            },
                            getContentAnchorEl: null,
                            className: 'selectDrop'
                        }
                    }}
                    inputProps={{ className: 'selected-item-name' }}
                >
                    {!Utils.isEmptyArray(selectList) &&
                        selectList.map(item => (
                            <MenuItem
                                passed="true"
                                data-cy="drop-down-item"
                                key={item.id}
                                defaultValue=""
                                value={item.name}
                                onClick={()=> handleChange(item)}
                            >
                                <OverFlowTooltipWithTabsMui
                                    value={item.name}
                                />
                            </MenuItem>
                        ))}
                </TextField>
        </Box>
    );
}

export default memo(DropdownSelect);
